module.exports = __webpack_public_path__ + "assets/img/title-cf713d30.png";